import { ReactNode } from 'react';
import { FeatureWrapper, StyledSpan } from '../../../../Skills/columns/styled';
import {
    StyledIconContainer,
    FacebookIcon,
    InstagramIcon,
    WhatsAppIcon,
    TiktokIcon,
    TelegramIcon,
} from './styled';

interface Props {
    row?: Record<string, unknown>;
    value?: string;
}

const iconMap: Record<string, ReactNode> = {
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
    whatsapp: <WhatsAppIcon />,
    tiktok: <TiktokIcon />,
    telegram: <TelegramIcon />,
};

const ChannelNameColumn = ({ row, value }: Props) => {
    const icon = row?.icon as string;

    return (
        <FeatureWrapper>
            <StyledIconContainer>
                {iconMap[icon] || null}
            </StyledIconContainer>
            <StyledSpan>
                {value}
            </StyledSpan>
        </FeatureWrapper>
    );
};

export default ChannelNameColumn;
